import { Component, OnInit ,Input} from '@angular/core';
import{CapabilityService,Site, App} from '../services/capability.service';
import { Observable } from 'rxjs';
import { FavoritesServices }from '@gea-mes/navbar';
import { StarEvent, FavIconLinkComponent } from '../fav-icon-link/fav-icon-link.component'
import { UserService } from '../services/user.service';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { ImagePreloadDirective } from '../directive/image-preload-directive.directive';
@Component({
    selector: 'app-site-mat-card',
    templateUrl: './site-mat-card.component.html',
    styleUrls: ['./site-mat-card.component.scss'],
    imports: [NgFor, MatCard, MatCardHeader, MatCardTitle, MatCardContent, ImagePreloadDirective, NgIf, FavIconLinkComponent, AsyncPipe]
})
export class SiteMatCardComponent implements OnInit {
  @Input() processCaps: Observable<any>;
  @Input() sites: Observable<any>;
  currentMenu : any;
  constructor(private capabilityService:CapabilityService, public userFavs: FavoritesServices, private userService: UserService) { }
  ngOnInit(): void {

    this.currentMenu = this.capabilityService.currentMenuValue;
    if(this.currentMenu == undefined){
      this.currentMenu = 'Manufacturing';
    }
  }
  
  changeFav(event: StarEvent, app: App, site: Site,aliasName:string) {
    let siteId = site ? site.name : null;
    let user = this.getMachineName()
    event.starred ? this.userFavs.addUserFavorite(app.name, siteId,aliasName, user) : this.userFavs.deleteUserFavorite(app.name, siteId,aliasName, user)
  }

  getMachineName() {
    return this.userService.getMachineName()
  }
}